if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          lightBox: document.querySelector('#custom-lightbox'),
          closeLightBox: document.querySelector('.custom-lightbox-gallery__close'),
          imgs: this.querySelectorAll('.product__modal-opener'),
          openerIcon: this.querySelectorAll('.product__modal-opener .product__media-icon'),
        };
        this.zoomRate = 1;
       
        this.thumPosition = 'horizontal';
        if (this.classList.contains('product__column-left')) {
          this.thumPosition = 'vertical';
        }
      
        this.elements.thumbnails ? this.mainThumb = new Swiper('.swiper-thumb', {
          direction: 'horizontal',
          loop: false,
          spaceBetween: 4,
          slidesPerView: "auto",
          watchSlidesProgress: true,
          resistanceRatio: 0.000001,
          lazyPreloadPrevNext: 1,
          observer: true,
          navigation: {
            prevEl: '.thumb-prev',
            nextEl: '.thumb-next',
          },
          mousewheel: {
            eventsTarget: '.swiper-thumb',
            forceToAxis: true,
            sensitivity: 0.5
          },
          freeMode: {
            enabled: true,
            momentum: false,
            momentumBounce: false,
          },
          breakpoints: {
            990: {
              direction: this.thumPosition,
            }
          },
        }) : null;

        this.mainSlider = new Swiper('.swiper-main', {
          loop: false,
          speed: 400,
          spaceBetween: 2,
          watchSlidesProgress: true,
          resistanceRatio: 0.000001,
          effect: "creative",
          observer: true,
          creativeEffect: {
            prev: {
              shadow: false,
              translate: ["-100%", 0, 0],
            },
            next: {
              shadow: false,
              translate: ["100%", 0, 0],
            },
          },
          navigation: {
            prevEl: '.main-slider-button--prev',
            nextEl: '.main-slider-button--next',
          },
          scrollbar: {
            el: ".swiper-main__scrollbar",
            hide: false,
            draggable: true,
          },
          zoom: {
            containerClass: 'swiper-zoom-container',
            minRatio: 1,
            maxRatio: 5,
            toggle: false,
            zoomedSlideClass: "is-zoomed"
          },
          thumbs: {
            swiper: this.mainThumb ? this.mainThumb : false,
            autoScrollOffset: .5
          }
        });

        if (this.elements.lightBox) {
          this.swiperModalThumb = new Swiper(".custom-lightbox-gallery__slider-thumb", {
            loop: false,
            spaceBetween: 4,
            direction: 'horizontal',
            slidesPerView: "auto",
            freeMode: true,
            watchSlidesProgress: true,
            observer: true,
            observeSlideChildren: true,
            mousewheel: true,
            threshold: 10,
            breakpoints: {
              990: {
                direction: 'vertical'
              }
            }
          });

          this.swiperModalGallery = new Swiper(".custom-lightbox-gallery__slider", {
            loop: false,
            speed: 400,
            slidesPerView: 1,
            spaceBetween: 24,
            mousewheel: true,
            direction: 'horizontal',
            observer: true,
            observeSlideChildren: true,
            resistanceRatio: 0.000001,
            freeMode: {
              enabled: false
            },
            thumbs: {
              swiper: this.swiperModalThumb,
            },
            scrollbar: {
              el: ".custom-lightbox-gallery__slider-scrollbar",
              hide: false,
              draggable: true,
              snapOnRelease: true
            },
            breakpoints: {
              990: {
                direction: 'vertical',
                speed: 200,
                scrollbar: {
                  snapOnRelease: false
                },
                slidesPerView: "auto",
                freeMode: {
                  enabled: true,
                  minimumVelocity: .001
                }
              }
            }
          });

          this.elements.imgs.forEach((img) => {
            if (!img) return;

            img.addEventListener('click', (e) => {
              if (window.innerWidth >= 990) {
                this.showLightbox(e.target);
              }
            });
          });

          this.elements.openerIcon.forEach((img) => {
            if (!img) return;

            img.addEventListener('click', (e) => {
              if (window.innerWidth < 990) {
                this.showLightbox(e.target);
              }
            });
          })

          this.elements.closeLightBox.addEventListener('click', () => {
            this.closeLightbox();
          })

          document.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE' && this.elements.lightBox.classList.contains('is-active')) {
              this.closeLightbox();
            }
          });

          if (this.classList.contains('swiper-hover-zoom')) {
            this.enableZoomOnClick();
          }
        }
      }

      showLightbox = (click_el = false) => {
        if (this.swiperModalGallery) {
          const activeSlide = click_el.closest('.swiper-slide');
          const index = [...activeSlide.parentElement.children].indexOf(activeSlide);
          this.swiperModalGallery.slideTo(index, 0);
        }

        this.elements.lightBox.classList.add('is-active');
        document.querySelector('html').classList.add('lightbox-open');
      }

      closeLightbox = () => {
        if (this.swiperModalGallery) {
          const activeSlide = document.querySelector('.custom-lightbox-gallery__slider .swiper-slide-active');
          const index = [...activeSlide.parentElement.children].indexOf(activeSlide);
          this.mainSlider.slideTo(index, 0);
        }

        this.elements.lightBox.classList.remove('is-active');
        document.querySelector('html').classList.remove('lightbox-open');
      }

      enableZoomOnClick = () => {
        const zoomIn = document.querySelector('.swiper-main__zoom-in');
        const zoomOut = document.querySelector('.swiper-main__zoom-out');
        const zoomReset = document.querySelector('.swiper-main__zoom-reset');
        const zoomPopup = document.querySelector('.swiper-main__zoom-popup');

        this.mainSlider.on('slideChange', () => {
          this.zoomRate = 1;
        });

        zoomIn.onclick = (event) => {
          if (this.zoomRate < 5) {
            this.zoomRate = this.zoomRate + 0.5;
            this.mainSlider.zoom.in(this.zoomRate);
          }
        };

        zoomOut.onclick = (event) => {
          if (this.zoomRate > 1) {
            this.zoomRate = this.zoomRate - 0.5;
            this.mainSlider.zoom.in(this.zoomRate);
          }
        };

        zoomReset.onclick = (event) => {
          this.zoomRate = 1;
          this.mainSlider.zoom.out();
        };

        zoomPopup.onclick = (event) => {
          this.showLightbox(document.querySelector('.swiper-main .swiper-slide-active .product__modal-opener'));
        } 
      }
    }
  );
}
